// extracted by mini-css-extract-plugin
module.exports = {"overallLink":"SubjectLinks_overallLink__Q_Jac","iconWrapper":"SubjectLinks_iconWrapper__2d3a_","iconWrapperNew":"SubjectLinks_iconWrapperNew__NEbNJ"};